import React, { Suspense } from "react";
import classNames from "classnames/bind";
import { Form, Field } from "react-final-form";
import useSWR from "swr";

import { Screen } from "../../components/Screen";
import { Loader } from "../../components/Loader";

import styles from "./Dietanamnez.module.css";
import { useStateManager } from "utils/useStateManager";
import { UserType } from "types/UserType";

const cx = classNames.bind(styles);

type Props = {
  onBack: () => void;
  onSubmit: (exists?: boolean) => void;
};

type FormValues = {
  custom_специфические_виды_питания: string[];
};

type KindsFoodItem = {
  key: string;
  custom_наименование: string;
  custom_light: boolean;
};

const KindsFood: React.FC<{ userType: UserType }> = ({ userType }) => {
  const { data } = useSWR<KindsFoodItem[]>([18, 356], {
    suspense: true,
  });

  return (
    <>
      {data
        ?.filter((item) => item.custom_light || userType === UserType.PRO)
        ?.map((item) => (
          <Field
            name="custom_специфические_виды_питания"
            type="checkbox"
            value={item.key}
            key={item.key}
          >
            {({ input }) => (
              <label className={cx("kindsFood")}>
                <input
                  type="checkbox"
                  {...input}
                  className={cx("kindsFoodCheckbox")}
                />
                <span className={cx("kindsFoodContent")}>
                  {item.custom_наименование}
                </span>
              </label>
            )}
          </Field>
        ))}
    </>
  );
};

export const Dietanamnez: React.FC<Props> = (props) => {
  const { userType, dietanamnez, updateDietanamnez } = useStateManager();

  const handleSubmit = async (values: FormValues) => {
    await updateDietanamnez(values);
    props.onSubmit();
  };

  return (
    <Form<FormValues>
      initialValues={{
        custom_специфические_виды_питания:
          dietanamnez?.custom_специфические_виды_питания || [],
      }}
      validateOnMount
      onSubmit={handleSubmit}
    >
      {({ handleSubmit, values, submitting }) => (
        <Screen
          title="Специфический вид питания"
          buttonTitle={
            values.custom_специфические_виды_питания.length > 0
              ? "Продолжить"
              : "Не следую ни одному из них"
          }
          onBack={props.onBack}
          onSubmit={handleSubmit}
          isLoading={submitting}
        >
          <div className={cx("subtitle")}>
            Следуете ли вы этим <br /> видам питания?
          </div>
          <p className={cx("advice")}>Выберите один или несколько</p>

          <div className={cx("list")}>
            <Suspense fallback={<Loader delay={300} />}>
              <KindsFood userType={userType} />
            </Suspense>
          </div>
        </Screen>
      )}
    </Form>
  );
};
